/* eslint-disable */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider, Modal, CardContent, Stack, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import MainCard from "components/MainCard";
import { Controller, useForm } from "react-hook-form";
import { useEffect } from "react";
import { getAttentionObservationsById, getEquipmentAlertsById } from "components/axios/equipmentAlertsAxios";
import dayjs from "dayjs";
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import CustomDateTimePicker from "components/date_picker/CustomDateTimePicker";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import moment from "moment";
import axios from "axios";
import { useEnumApi } from "contexts/EnumApiContext";
import { getEquipmentCategoriesById, getEquipmentCategoriesByQuery, getMasterEquipmentPartsById, getMasterEquipmentPartsByQuery } from "components/axios/equipmentCategoryAxios";
import { useRef } from "react";
import CustomFormSelect from "components/select/CustomFormSelect";
import { getMaintenanceTasksById } from "components/axios/maintenanceAxios";
import { LoadingButton } from "@mui/lab";
import FileDownloadIcon from "components/FileDownloadIcon";
import { orderString } from "data/data";
import EquipmentPartListLayer from "./EquipmentPartListLayer";
import CustomDatePicker from "components/date_picker/CustomDatePicker";
import { useSelector } from "react-redux";
import Chip from '@mui/material/Chip';
import { customFileAxios } from "components/axios/customAxios";

const ConstantInspectionFollowActionTypeRequestLayer = ({alertId,  setIsLoading:setParentIsLoading, type}) => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode } = useEnumApi();
    const { name } = useSelector(state => state.user);
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };
    
    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const regexDateTime = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]) (0[0-9]|1[0-9]|2[0-3]):(0[1-9]|[0-5][0-9])$/);
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true); setIsLoading(false); };
    const handleClose = () => setOpen(false);
  
    const { control, register , handleSubmit , reset
        , setValue , watch, formState : { isDirty , errors } } = useForm({});

    // 상황보고 필드 값 감시
    const watchDtl = watch("reportDtl");
    const watchDate = watch("reportYmd");
    const watchReporter = watch("reportUser");

    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);

    const [equipmentAlert, setEquipmentAlert] = useState(null);
    const [fllwActionTypes, setFllwActionTypes] = useState(null);

    const [attentionObservation, setAttentionObservation] = useState({});
    const [maintenanceTask, setMaintenanceTask] = useState({});

    const [mtStatuss, setMtStatuss] = useState([]);
    const [equipmentCategoryComponents, setEquipmentCategoryComponents] = useState(null);
    const [equipmentCategoryPositions, setEquipmentCategoryPositions] = useState(null);
    
    const [equipmentCategoryComponentId, setEquipmentCategoryComponentId] = useState(null);
    const [masterEquipmentParts, setMasterEquipmentParts] = useState(null);
  
    const nextID = useRef(1);
    const [inputFiles, setInputFiles] = useState([]);

    const nextPartID = useRef(1);
    const [inputParts, setInputParts] = useState([]);
  
    function addInputFile(file) {
      const input = {	
          id: nextID.current,
          file: {},
          rFile: file,
      };

      setInputFiles([...inputFiles, input]);
      nextID.current += 1;
    }

    // 삭제
    function deleteInputFile(index) {
        setInputFiles(inputFiles.filter(item => item.id !== index));
    }

    function handleInputFileChange(e, index) {
        if (index > inputFiles.length) return;
        
        let inputFilesCopy = [...inputFiles];
        inputFilesCopy[index].file = e.target.files[0];
        inputFilesCopy[index].rFile = null;
        setInputFiles(inputFilesCopy);
    }

    function addParts() {
      const input = {
        id: nextPartID.current,
        part : {
          id : 0,
          partId: 0,
          partLifeSpanTime : 0,
          count: 0,
        }
      };
  
      setInputParts([...inputParts, input]);
      nextPartID.current += 1;
    }
  
    // 삭제
    function deleteInputPart(index) { 
      setInputParts(inputParts.filter(item => item.id !== index));
    }
  
    function handleInputPartChange(e, index) {
        if (index > inputParts.length) return;
        const mPartId = e.target.value;
  
        Promise.all([
          getMasterEquipmentPartsById(mPartId).then((res)=>{
            let inputPartsCopy = [...inputParts];
            inputPartsCopy[index].part.partId = mPartId;
            inputPartsCopy[index].part.partLifeSpanTime = res.lifeSpanTime;
            setInputParts(inputPartsCopy);
          })
        ]);
    }
    
    function handleInputPartCountChange(e, index) {
        if (index > inputParts.length) return;
        
        let inputPartsCopy = [...inputParts];
        inputPartsCopy[index].part.count = e.target.value;
        setInputParts(inputPartsCopy);
    }

    useEffect(()=>{
      const list = getEnumValueByEnumName("FollowActionType");
      if (list) {
        let fllwActionTypeList = list.filter(type=>type.code!=='O1_WAIT');
        setFllwActionTypes(fllwActionTypeList);
      }
    },[getEnumValueByEnumName("FollowActionType")]);

    useEffect(()=>{
      if (alertId && open) {
        Promise.all([
          getEquipmentAlertsById(alertId).then((data)=>{
            setEquipmentAlert(data);
          })
        ]).then((res)=>{
          setIsLoading(true);
        })
      }
    },[alertId, isLoading, open]);

    useEffect(() => {
      if (equipmentAlert && equipmentAlert.fllwActionType && (equipmentAlert.fllwActionType === 'O2_OBSERVE' || equipmentAlert.fllwActionType === 'O3_MNT')) {
        if (equipmentAlert.fllwActionType === 'O2_OBSERVE' && equipmentAlert.atentObserv && equipmentAlert.atentObserv.id) {
          getAttentionObservationsById(equipmentAlert.atentObserv.id).then((data2)=>{
            if (data2) {
              setAttentionObservation(data2)
            }
          })
        } else if (equipmentAlert.fllwActionType === 'O3_MNT') {
          const equipmentCtgrId = equipmentAlert.equipment.equipmentCtgr.id;
          if (equipmentCtgrId && equipmentAlert.mntTask && equipmentAlert.mntTask.id) {
            Promise.all([
              getEquipmentCategoriesById(equipmentCtgrId).then((data) => {
                if (data && data.positions) {
                  let positions = [];
                  data.positions.map(function(item) {
                    positions.push({id:item, name:item});
                  })
                  orderString(positions,"id");
                  setEquipmentCategoryPositions(positions);
                } else {
                  setEquipmentCategoryPositions(null);
                }
              })
              ,
              getEquipmentCategoriesByQuery({"parent.id": equipmentCtgrId, depth: 4, size : 100, sort : "name,asc"}).then((data) => {
                if (data && data._embedded) {
                  setEquipmentCategoryComponents(data._embedded.equipmentCategories);
                } else {
                  setEquipmentCategoryComponents(null);
                }
              })
              ,
              getMaintenanceTasksById(equipmentAlert.mntTask.id).then((data2)=>{ // 유지보수내역
                if (data2) {
                  setMaintenanceTask(data2)
                }
              })
            ]).then((res2)=>{
              setMtStatuss(getEnumValueByEnumName("MaintenanceStatus").filter(item=>(item.code !== 'O1_R' && item.code !== 'O4_V')))
            });
          }
        }
      }
    },[equipmentAlert]);

    useEffect(()=>{
      if (equipmentCategoryComponentId) {
        getMasterEquipmentPartsByQuery({ "equipmentCtgr.id": equipmentCategoryComponentId, size:100 }).then((data)=>{
          if (data && data._embedded) {
            setMasterEquipmentParts(data._embedded.masterEquipmentParts);
          }
        })
      }
    },[equipmentCategoryComponentId]);

    const onSubmit = (data) => {
      if (data.fieldChkedAt != null && data.fieldChkedAt != '' && !regexDateTime.test(data.fieldChkedAt)) {
        alertMessage = t('message.common.alert.constantInspection.checkedAt.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      let fieldChkedAt = (data.fieldChkedAt?.$d != null ? moment(data.fieldChkedAt.$d).toISOString() : dayjs(data.fieldChkedAt).toISOString());

      let dto = {
        id : alertId,
        equipment : {
          id : equipmentAlert.equipment.id
        },
        fieldChkedAt : fieldChkedAt,
        fieldChkUser : data.fieldChkUser,
        status : "M",  // 점검확인
        fllwActionType : data.fllwActionType
      }

      if (data.fllwActionType === 'O2_OBSERVE') {
        dto.atentObserv = {}
      } else if (data.fllwActionType === 'O3_MNT') {
        dto.mntTask = {}
      }
console.log(dto)

      let formData = new FormData();
      
      formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
              const res = customFileAxios.patch(`/api/equipmentAlerts/${alertId}`, formData).then((res)=>{
                  // console.log(res)
                  //setFileLoading(false);
                  //refreshEquipments();
                  alertMessage = t('message.common.alert.write.done');
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                  //setFllwActionType(data.fllwActionType);
                  if (data.fllwActionType === 'O2_OBSERVE' || data.fllwActionType === 'O3_MNT') {
                    if (data.fllwActionType === 'O2_OBSERVE') {
                      getAttentionObservationsById(res.data.atentObserv.id).then((data2)=>{
                        // console.log(data2);
                        if (data2) {
                          setAttentionObservation(data2)
                          setValue("plannedEndYmd",null);
                          setValue("reportYmd",null);
                        }
                      })
                    } else if (data.fllwActionType === 'O3_MNT') {
                      getMaintenanceTasksById(res.data.mntTask.id).then((data2)=>{ // 유지보수내역
                        console.log(data2);
                        if (data2) {
                          setMaintenanceTask(data2)
                          setValue("reportYmd",null);
                        }
                      })
                    }
                    setIsLoading(false);
                  } else {
                    setParentIsLoading(false);
                  }
                  reset();
                  if (data.fllwActionType !== 'O2_OBSERVE' && data.fllwActionType !== 'O3_MNT') {
                    handleClose();
                  }
              }).catch((err)=>{
                  console.log(err);
                  //setFileLoading(false);
                  if (!err.response?.data?.message) {
                      alertMessage = err.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  } else if (err.response.data.message) {
                      alertMessage = err.response.data.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  }
              });
              // return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }

          // axios({
          //   method: "patch",
          //   url: process.env.REACT_APP_API_URL+"/api/equipmentAlerts/"+alertId,
          //   data: formData,
          //   headers : {
          //       'Content-type' : 'multipart/form-data',
          //       accept : 'application/json,',
          //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
          //       'Accept-Language' : t('locale')
          //   }
          // }).then((res)=>{
          //     alertMessage = t('message.common.alert.write.done');
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //     if (data.fllwActionType === 'O2_OBSERVE' || data.fllwActionType === 'O3_MNT') {
          //       if (data.fllwActionType === 'O2_OBSERVE') {
          //         getAttentionObservationsById(res.data.atentObserv.id).then((data2)=>{
          //           if (data2) {
          //             setAttentionObservation(data2)
          //             setValue("plannedEndYmd",null);
          //             setValue("reportYmd",null);
          //           }
          //         })
          //       } else if (data.fllwActionType === 'O3_MNT') {
          //         getMaintenanceTasksById(res.data.mntTask.id).then((data2)=>{ // 유지보수내역
          //           if (data2) {
          //             setMaintenanceTask(data2)
          //             setValue("reportYmd",null);
          //           }
          //         })
          //       }
          //       setIsLoading(false);
          //     } else {
          //       setParentIsLoading(false);
          //     }
          //     reset();
          //     if (data.fllwActionType !== 'O2_OBSERVE' && data.fllwActionType !== 'O3_MNT') {
          //       handleClose();
          //     }
          // }).catch((err)=>{
          //     console.log(err);
          //     if (!err.response?.data?.message) {
          //         alertMessage = err.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     } else if (err.response.data.message) {
          //         alertMessage = err.response.data.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     }
          // });
        },
        onClose : () => {
            console.log('close');
        },
        message: t('message.common.alert.write.question'),
      });
    }
    
    const onAttentionObservationSubmit = (data, e) => {
      setFileLoading(true);
      if (data.plannedEndYmd === null || data.plannedEndYmd === '') {
        alertMessage = t('message.common.alert.observe.endYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      if (data.plannedEndYmd != null && data.plannedEndYmd != '' && !regexDate.test(data.plannedEndYmd)) {
        alertMessage = t('message.common.alert.observe.endYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.regYmd === null || data.regYmd === '') {
        alertMessage = t('message.common.alert.observe.startYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      if (data.regYmd != null && data.regYmd != '' && !regexDate.test(data.regYmd)) {
        alertMessage = t('message.common.alert.observe.startYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      
      let dto = {
        equipmentAlert : {id:alertId},
        equipment : {id:equipmentAlert.equipment.id},
        plannedEndYmd : data.plannedEndYmd,
        regUser : data.regUser,
        regYmd : data.regYmd,
        remark : data.remark,
      }

      let statusReport = {};
      if (data.reportDtl || data.reportUser || data.reportYmd) {
        statusReport = {
          "reportDtl" : data.reportDtl,
          "reportUser" : data.reportUser,
          "reportYmd" : data.reportYmd,
        }
        dto.statusReport = statusReport;
      }

      let formData = new FormData();
      let fileCnt = 0;
      if(inputFiles) {
        for (var l=0;l<inputFiles.length;l++) {
            if (inputFiles[l].file && inputFiles[l].file.name) {
                formData.append("statusFiles", inputFiles[l].file);
                fileCnt++;
            }
        }
      }

        dto.id = attentionObservation.id;
        let rfileCnt = 0;
        if (inputFiles) {
            let rFiles = [];
            for (var a2=0;a2<inputFiles.length;a2++) {
                if (inputFiles[a2].rFile && inputFiles[a2].rFile.id) {
                    rFiles.push({id : inputFiles[a2].rFile.id});
                    rfileCnt++;
                }
            }
            statusReport.reportFiles = rFiles;
        }
        if (attentionObservation.statusReport && attentionObservation.statusReport.id)
          statusReport.id = (attentionObservation.statusReport && attentionObservation.statusReport.id);

        if (data.reportYmd || data.reportUser || data.reportDtl || (fileCnt + rfileCnt) > 0) {
          if (data.reportDtl === null || data.reportDtl === undefined || data.reportDtl === '') {
            alertMessage = t('message.common.alert.status.report.detail.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
          if ((fileCnt + rfileCnt) === 0) {
            alertMessage = t('message.common.alert.status.report.file.write');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
          if (data.reportUser === null || data.reportUser === undefined || data.reportUser === '') {
            alertMessage = t('message.common.alert.status.reporter.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
          if (data.reportYmd === null || data.reportYmd === undefined || data.reportYmd === '') {
            alertMessage = t('message.common.alert.status.report.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
          if (data.reportYmd != null && data.reportYmd != '' && !regexDate.test(data.reportYmd)) {
            alertMessage = t('message.common.alert.status.report.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }

        }

        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
        
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            try {
                const res = customFileAxios.patch(`/api/attentionObservations/${attentionObservation.id}`, formData).then((res)=>{
                    //console.log(res);
                    alertMessage = t('message.common.alert.modify.done');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                    setFileLoading(false);
                    setParentIsLoading(false);
                    reset();
                    handleClose();
                    //navigate('../modify/'+res.data.id+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    setFileLoading(false);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
                // return res.data;
            } catch (error) {
                console.error("error :", error);
                throw error;
            }

            // axios({
            //   method: "patch",
            //   url: process.env.REACT_APP_API_URL+"/api/attentionObservations/"+attentionObservation.id,
            //   data: formData,
            //   headers : {
            //       'Content-type' : 'multipart/form-data',
            //       accept : 'application/json,',
            //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
            //       'Accept-Language' : t('locale')
            //   }
            // }).then((res)=>{
            //     alertMessage = t('message.common.alert.modify.done');
            //     setAlertMessage(alertMessage);
            //     handleAlertClick();
            //     setFileLoading(false);
            //     setParentIsLoading(false);
            //     reset();
            //     handleClose();
            // }).catch((err)=>{
            //     console.log(err);
            //     setFileLoading(false);
            //     if (!err.response?.data?.message) {
            //         alertMessage = err.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     } else if (err.response.data.message) {
            //         alertMessage = err.response.data.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     }
            // });
          },
          onClose : () => {
              console.log('close');
              setFileLoading(false);
          },
          message: t('message.common.alert.modify.question'),
        });
    }

    const hasAnyValue = watchDtl || watchDate || watchReporter || (inputFiles && inputFiles.length > 0);
    const onMaintenanceTaskSubmit = (data,e) => {
      setFileLoading(true);
  
      if (data.troubledAt != null && data.troubledAt != '' && !regexDateTime.test(data.troubledAt)) {
        alertMessage = t('message.common.alert.breakdown.maintenance.datetime.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.workingBgnAt != null && data.workingBgnAt != '' && !regexDateTime.test(data.workingBgnAt)) {
        alertMessage = t('message.common.alert.work.start.datetime.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.workingEndAt != null && data.workingEndAt != '' && !regexDateTime.test(data.workingEndAt)) {
        alertMessage = t('message.common.alert.work.end.datetime.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.troubledAt >= data.workingEndAt) {
        alertMessage = t('message.common.alert.work.end.datetime.not.equal.breakdown.datetime');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      
      let dto = {
        equipment : {id: equipmentAlert.equipment.id},
        equipmentAlert : {id: alertId},
        equipmentCtgr : {id: data.componentId},
        cost : data.cost,
        mntSpType : data.mntSpType,
        importantYn : data.importantYn,
        position : data.position,
        recordType : data.recordType,
        remark : data.remark,
        status : data.status,
        troubleReason : data.troubleReason,
        troubledAt : (data.troubledAt?.$d != null ? moment(data.troubledAt.$d).format() : dayjs(data.troubledAt).format()),
        type : data.type,
        usedMethod : data.usedMethod,
        worker : data.worker,
        workingBgnAt : (data.workingBgnAt?.$d != null ? moment(data.workingBgnAt.$d).format() : dayjs(data.workingBgnAt).format()),
        workingEndAt : (data.workingEndAt?.$d != null ? moment(data.workingEndAt.$d).format() : dayjs(data.workingEndAt).format()),
      }
  
      let statusReport = {};
      if (data.reportUser || data.reportYmd) {
        statusReport = {
          "reportUser" : data.reportUser,
          "reportYmd" : data.reportYmd,
        }
        dto.statusReport = statusReport;
      }
  
      let formData = new FormData();
  
      let fileCnt = 0;
      if(inputFiles) {
        for (var l=0;l<inputFiles.length;l++) {
            if (inputFiles[l].file && inputFiles[l].file.name) {
                formData.append("statusFiles", inputFiles[l].file);
                fileCnt++;
            }
        }
      }
  
      let equipmentParts = [];
      let isDuple = false;
      if(inputParts && inputParts.length > 0) {
        for (var m=0;m<inputParts.length;m++) {
            if (inputParts[m].part.partId) {
              let dupleChk = inputParts.filter(item => item.part.partId === inputParts[m].part.partId);
              if (dupleChk.length > 1) {
                isDuple = true;
                break;
              } else {
                if (inputParts[m].part.id !== 0) {
                  equipmentParts.push({
                    id:inputParts[m].part.id, 
                    cnt : inputParts[m].part.count
                  })
                } else {
                  equipmentParts.push({
                    lifeSpanTime:inputParts[m].part.partLifeSpanTime, 
                    masterEquipmentPart:{
                      id:inputParts[m].part.partId
                    }, 
                    position : data.position,
                    cnt : inputParts[m].part.count
                  })
                }
              }
            }
        }
        dto.equipmentParts = equipmentParts;
      }
  
      if (data.status === 'O3_C' && equipmentParts.length === 0) {
        alertMessage = t('message.common.alert.material.select.add');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (isDuple) {
        alertMessage = t('message.common.alert.duplication.material.check.again');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
  
      if(maintenanceTask && (maintenanceTask.status !== 'O3_C' && maintenanceTask.status !== 'O4_V') ) {  // 수정
        dto.id = maintenanceTask.id;
        let rfileCnt = 0;
        if (inputFiles) {
            let rFiles = [];
            for (var a2=0;a2<inputFiles.length;a2++) {
                if (inputFiles[a2].rFile && inputFiles[a2].rFile.id) {
                    rFiles.push({id : inputFiles[a2].rFile.id});
                    rfileCnt++;
                }
            }
            if (rFiles.length > 0)
              statusReport.reportFiles = rFiles;
        }
        if (maintenanceTask.statusReport && maintenanceTask.statusReport.id)
          statusReport.id = (maintenanceTask.statusReport && maintenanceTask.statusReport.id);
        
        if (data.reportYmd || data.reportUser || (fileCnt+rfileCnt) > 0) {
          if (data.reportYmd === null || data.reportYmd === undefined || data.reportYmd === '') {
            alertMessage = t('message.common.alert.status.report.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
          if (data.reportYmd != null && data.reportYmd != '' && !regexDate.test(data.reportYmd)) {
            alertMessage = t('message.common.alert.status.report.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
          if (data.reportUser === null || data.reportUser === undefined || data.reportUser === '') {
            alertMessage = t('message.common.alert.status.reporter.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
          if ((fileCnt+rfileCnt) === 0) {
            alertMessage = t('message.common.alert.status.report.file.write');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
          }
        }

        if (dto.status === 'O1_R') {
          alertMessage = t('message.common.alert.work.status.select');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }

        if (maintenanceTask.status === 'O4_V') {//(확인) - 상태, 자재 수정 불가
          delete dto.equipmentParts;
          delete dto.status;
        }

        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
  
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            try {
                const res = customFileAxios.patch(`/api/maintenanceTasks/${maintenanceTask.id}`, formData).then((res)=>{
                    //console.log(res);
                    // setIsFollowActionTypeOpen(false);
                    alertMessage = t('message.common.alert.modify.done');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                    setFileLoading(false);
                    setParentIsLoading(false);
                    reset();
                    handleClose();
                    //navigate('../modify/'+res.data.id+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    setFileLoading(false);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
                // return res.data;
            } catch (error) {
                console.error("error :", error);
                throw error;
            }

            // axios({
            //   method: "patch",
            //   url: process.env.REACT_APP_API_URL+"/api/maintenanceTasks/"+maintenanceTask.id,
            //   data: formData,
            //   headers : {
            //       'Content-type' : 'multipart/form-data',
            //       accept : 'application/json,',
            //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
            //       'Accept-Language' : t('locale')
            //   }
            // }).then((res)=>{
            //     alertMessage = t('message.common.alert.modify.done');
            //     setAlertMessage(alertMessage);
            //     handleAlertClick();
            //     setFileLoading(false);
            //     setParentIsLoading(false);
            //     reset();
            //     handleClose();
            // }).catch((err)=>{
            //     console.log(err);
            //     setFileLoading(false);
            //     if (!err.response?.data?.message) {
            //         alertMessage = err.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     } else if (err.response.data.message) {
            //         alertMessage = err.response.data.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     }
            // });
          },
          onClose : () => {
              console.log('close');
              setFileLoading(false);
          },
          message: t('message.common.alert.modify.question'),
        });
      }
    }
    return (
      <>
        {type && type === 'icon' &&
        <Button variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset"}} color="grey">
          <span className="icon_png" style={{color:"#fff"}}><img src={`${process.env.PUBLIC_URL}/img/icon/content_paste_search.png`} alt='' /></span>
        </Button>
        }
        {(type === null || type === undefined || type === 'button') &&
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset"}}>
          {t('message.common.subtitle.constantInspection')}
        </Button>
        }
        
        {isLoading &&
        <Modal className="pop_box pop_box4" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard modal darkTitle content={false}>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px"}}>
              <div>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                <Chip label={t('message.common.chip.constantInspection')} color="error" />
              </div>

              <div>
                <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
            </div>

            <CardContent>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TableContainer>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width pop_table view_table">
                  <TableBody>
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.subwayline')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.workingPart
                       && equipmentAlert.equipment.station.workingPart.subwayLine && getEnumValueByEnumNameAndCode("SubwayLine", equipmentAlert.equipment.station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", equipmentAlert.equipment.station.workingPart.subwayLine)[0].title}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.workingPart && equipmentAlert.equipment.station.workingPart.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.station')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.name}</TableCell>
                    </TableRow> */}
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level1')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.parent && equipmentAlert.equipment.equipmentCtgr.parent.parent && equipmentAlert.equipment.equipmentCtgr.parent.parent.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.parent && equipmentAlert.equipment.equipmentCtgr.parent.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level3')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.name}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.number')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentNo}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertedAt')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && dayjs(equipmentAlert.latestAlertedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.alertType')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.alertType && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType) && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType)[0].title}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertCategory')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory) && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory)[0].title}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.alertDetail')}</TableCell>
                      <TableCell colSpan="3" className="view_td_left" style={{whiteSpace:"pre-line"}}>{equipmentAlert && equipmentAlert.alertDtl}</TableCell>
                    </TableRow>
                    {equipmentAlert && equipmentAlert.fieldChkedAt && equipmentAlert.fieldChkUser && equipmentAlert.fllwActionType !== 'O1_WAIT' ? 
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.checkedAt')}</TableCell>
                      <TableCell className="view_td">
                        {dayjs(equipmentAlert.fieldChkedAt).format("YYYY-MM-DD HH:mm")}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.confirm.user')}</TableCell>
                      <TableCell className="view_td">
                        {equipmentAlert.fieldChkUser}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.status')}</TableCell>
                      <TableCell className="view_td">
                        {getEnumValueByEnumNameAndCode("EquipmentAlertStatus", equipmentAlert.status) && getEnumValueByEnumNameAndCode("EquipmentAlertStatus", equipmentAlert.status)[0].title}
                      </TableCell>
                    </TableRow>
                      :
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.checkedAt')} *</TableCell>
                      <TableCell className="view_td">
                        <Controller
                            control={control}
                            name="fieldChkedAt"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDateTimePicker
                                defaultValue={equipmentAlert.fieldChkedAt ? dayjs(equipmentAlert.fieldChkedAt).format('YYYY-MM-DD HH:mm') : dayjs(dayjs(equipmentAlert.latestAlertedAt).add(3,'minute')).format('YYYY-MM-DD HH:mm')}
                                field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                                fieldState={fieldState}
                                requiredMessage={t('message.common.error.text.constantInspection.checkedAt.input')}
                            />
                            )}
                        />
                        {errors.fieldChkedAt && <small role="alert"><br></br>{errors.fieldChkedAt.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.confirm.user')} *</TableCell>
                      <TableCell colSpan={3} className="view_td view_td1" style={{textAlign: "left"}}>
                        <TextField id="outlined-basic" 
                            aria-invalid={!isDirty ? undefined : errors.fieldChkUser ? "true" : "false"}
                            defaultValue={equipmentAlert.fieldChkUser || name}
                            {...register("fieldChkUser", {
                                required : t('message.common.error.text.constantInspection.confirm.user.input')
                            })}  />
                        {errors.fieldChkUser && <small role="alert"><br></br>{errors.fieldChkUser.message}</small>}
                      </TableCell>
                    </TableRow>
                    }
                    {equipmentAlert && equipmentAlert.fieldChkedAt && equipmentAlert.fieldChkUser && equipmentAlert.fllwActionType !== 'O1_WAIT' ? 
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.fllwActionType')}</TableCell>
                      <TableCell colSpan="5" className="view_td">
                        {equipmentAlert.fllwActionType && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}
                      </TableCell>
                    </TableRow>
                    :
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.fllwActionType')} *</TableCell>
                      <TableCell colSpan="5" className="view_td view_td1" style={{textAlign: "left"}}>
                        {fllwActionTypes &&
                        <Controller
                            sx={{ m: 1, minWidth: "200px" }}
                            aria-invalid={!isDirty ? undefined : errors.fllwActionType ? "true" : "false"}
                            control={control}
                            name="fllwActionType"
                            render={({ field: {name} }) => (
                            <CustomFormEnumSelect
                                style={{ minWidth: '200px' }}
                                label={t('message.common.subtitle.fllwActionType')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.fllwActionType.select')}
                                defaultValue={'O4_NORMAL'}
                                list={fllwActionTypes}
                            />
                            )}
                        />
                        }
                        {errors.fllwActionType && <small role="alert"><br></br>{errors.fllwActionType.message}</small>}
                      </TableCell>
                    </TableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </form>

            {equipmentAlert && equipmentAlert.fieldChkedAt && equipmentAlert.fieldChkUser && equipmentAlert.fllwActionType !== 'O1_WAIT' ? 
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <Button variant="contained" size="small" onClick={handleClose}>
                {t('message.common.btn.confirm')}
              </Button>
            </Stack>
            : 
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <Button variant="contained" size="small" onClick={handleSubmit(onSubmit)}>
                {t('message.common.btn.write')}
              </Button>
              <Button variant="contained" color="error" size="small" onClick={handleClose}>
                {t('message.common.btn.cancel')}
              </Button>
            </Stack>
            }

            {
              equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation && attentionObservation.remark === undefined && 
            <>
              <form onSubmit={handleSubmit(onAttentionObservationSubmit)}>
                <TableContainer>
                  <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width pop_table view_table">
                    <TableBody>
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.observe.endYmd')} *</TableCell>
                        <TableCell colSpan="5" className="view_td_left">
                          <Controller
                              control={control}
                              name="plannedEndYmd"
                              render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDatePicker
                                  field={field} ref={ref} name={name} value={value} register={register} 
                                  fieldState={fieldState}
                                  requiredMessage={t('message.common.error.text.observe.endYmd.select')}
                              />
                              )}
                          />
                          {errors.plannedEndYmd && <small role="alert"><br></br>{errors.plannedEndYmd.message}</small>}
                        </TableCell>
                      </TableRow>
    
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.observe.detail')} *</TableCell>
                        <TableCell colSpan="5" className="view_td_left">
                          <TextField style={{width:"98%"}} id="outlined-basic" 
                              aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                              {...register("remark", {
                                  required : t('message.common.error.text.observe.detail.input')
                              })} 
                              multiline
                              rows={4}
                              sx={{ minWidth: '90%' }} />
                          {errors.remark && <small role="alert"><br></br>{errors.remark.message}</small>}
                        </TableCell>
                      </TableRow>
    
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.observe.write.date')} *</TableCell>
                        <TableCell className="view_td_left" colSpan="2">
                          <Controller
                              control={control}
                              name="regYmd"
                              render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDatePicker
                                  defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                  field={field} ref={ref} name={name} value={value} register={register} 
                                  fieldState={fieldState}
                                  requiredMessage={t('message.common.error.text.observe.write.date.select')}
                              />
                              )}
                          />
                          {errors.regYmd && <small role="alert"><br></br>{errors.regYmd.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.observe.writer')} *</TableCell>
                        <TableCell colSpan="2" className="view_td_left" >
                        <TextField id="outlined-basic" 
                              aria-invalid={!isDirty ? undefined : errors.regUser ? "true" : "false"}
                              defaultValue={name || ''}
                              {...register("regUser", {
                                  required : t('message.common.error.text.observe.writer.input')
                              })} 
                              sx={{ minWidth: '60%' }} />
                          {errors.regUser && <small role="alert"><br></br>{errors.regUser.message}</small>}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.status.report.detail')}</TableCell>
                        <TableCell colSpan="5" className="view_td_left" >
                          <TextField style={{width:"98%"}} id="outlined-basic" 
                              {...register("reportDtl", {
                                validate: (value) =>
                                !hasAnyValue || value ? true : t('message.common.alert.status.report.detail.input'),
                              })} 
                              multiline
                              rows={4}
                              sx={{ minWidth: '90%' }} />
                              {errors.reportDtl && <small role="alert"><br></br>{errors.reportDtl.message}</small>}
                        </TableCell>
                      </TableRow>
    
                      <TableRow>
                        <TableCell className="th">
                        {t('message.common.subtitle.status.report.file')}
                          <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addInputFile}>+</AddCircleOutlineIcon>
                        </TableCell>
                        <TableCell colSpan="5" className="view_td_left" >
                          {inputFiles && inputFiles.map(function(item, index) {
                            return (
                              <div key={index} style={{display:"flex"}}>
                                <input
                                    type="file"
                                    value={''}
                                    style={{width:"unset"}}
                                    onChange={e => {
                                      handleInputFileChange(e, index);
                                    }}
                                />
                                {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.id && <><FileDownloadIcon file={item.rFile} viewFileName={true} fontColor={"#000"}/></>)}
                                { inputFiles[index] ? (
                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputFile(item.id)}>-</RemoveCircleOutlineIcon>
                                ) : (
                                ''
                                )}
                            </div>
                            )
                            })}
                            {hasAnyValue && inputFiles.length === 0 && (
                              <small role="alert"><br></br>{t('message.common.alert.status.report.file.write')}</small>
                            )}
                          </TableCell>
                      </TableRow>
    
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.status.reporter')}</TableCell>
                        <TableCell>
                          <TextField style={{width:"90%"}} id="outlined-basic" 
                              {...register("reportUser", {
                                validate: (value) =>
                                !hasAnyValue || value ? true : t('message.common.alert.status.reporter.input'),
                              })} 
                              sx={{ minWidth: '60%' }} />
                               {errors.reportUser && <small role="alert"><br></br>{errors.reportUser.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.status.report.date')}</TableCell>
                        <TableCell className="view_td_left" colSpan="3">
                        <Controller
                              control={control}
                              name="reportYmd"
                              render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDatePicker
                                  field={field} ref={ref} name={name} value={value} register={register} 
                                  fieldState={fieldState}
                                  hasAnyValue={hasAnyValue}
                                  validateMessage={t('message.common.alert.status.report.date.input')}
                              />
                              )}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </form>

              <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
                <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onAttentionObservationSubmit)}>{t('message.common.btn.observe.write')}</LoadingButton>
                <Button variant="contained" color="error" size="small" onClick={handleClose}>
                  {t('message.common.btn.cancel')}
                </Button>
              </Stack>
            </>
            }

            {
              equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask && maintenanceTask.mntSpType === undefined &&
            <>
              <form onSubmit={handleSubmit(onMaintenanceTaskSubmit)}>
                <TableContainer>
                  <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width pop_table view_table">
                    <TableBody>
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.breakdown.maintenance')}<br />{t('message.common.subtitle.occurrence.datetime')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            control={control}
                            name="troubledAt"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDateTimePicker 
                                defaultValue={dayjs(new Date()).format('YYYY-MM-DD HH:mm')}
                                field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                                fieldState={fieldState}
                                requiredMessage={t('message.common.error.text.breakdown.maintenance.datetime.input')}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.breakdown.maintenance')}<br />{t('message.common.subtitle.cause')} *</TableCell>
                        <TableCell className="view_td" colSpan={3}>
                          <TextField style={{width:"97%"}} id="outlined-basic" 
                            aria-invalid={!isDirty ? undefined : errors.troubleReason ? "true" : "false"}
                            {...register("troubleReason", {
                                required : t('message.common.error.text.breakdown.maintenance.cause.input')
                            })} 
                            defaultValue={''}
                            sx={{ minWidth: '90%' }} />
                          {errors.troubleReason && <small role="alert"><br></br>{errors.troubleReason.message}</small>}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.analysis.type')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            aria-invalid={!isDirty ? undefined : errors.recordType ? "true" : "false"}
                            control={control}
                            name="recordType"
                            render={({ field: {name} }) => (
                            <CustomFormEnumSelect
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.analysis.type')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.analysis.type.select')}
                                defaultValue={''}
                                list={getEnumValueByEnumName("MaintenanceRecordType")}
                            />
                            )}
                          />
                          {errors.recordType && <small role="alert"><br></br>{errors.recordType.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.provider.type')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            aria-invalid={!isDirty ? undefined : errors.mntSpType ? "true" : "false"}
                            control={control}
                            name="mntSpType"
                            render={({ field: {name} }) => (
                            <CustomFormEnumSelect
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.provider.type')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.provider.type.select')}
                                defaultValue={''}
                                list={getEnumValueByEnumName("MaintenanceProviderType")}
                            />
                            )}
                          />
                          {errors.mntSpType && <small role="alert"><br></br>{errors.mntSpType.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.main.management')}</TableCell>
                        <TableCell className="view_td">
                          <input type="checkbox" id="importantYn" {...register("importantYn", {
                          })}  />&nbsp;&nbsp;<label htmlFor="importantYn" style={{cursor:"pointer", color:"#000"}}></label>
                        </TableCell>
                      </TableRow>
          
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.work.start.datetime')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            control={control}
                            name="workingBgnAt"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDateTimePicker 
                                defaultValue={dayjs(new Date()).format('YYYY-MM-DD HH:mm')}
                                field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                                fieldState={fieldState}
                                requiredMessage={t('message.common.error.text.work.start.datetime.input')}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.work.end.datetime')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            control={control}
                            name="workingEndAt"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                              <CustomDateTimePicker 
                                defaultValue={dayjs(new Date()).format('YYYY-MM-DD HH:mm')}
                                field={field} style={{width:"90%"}} ref={ref} name={name} value={value} register={register} 
                                fieldState={fieldState}
                                requiredMessage={t('message.common.error.text.work.end.datetime.input')}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.used.equipment')}</TableCell>
                        <TableCell className="view_td">
                          <TextField style={{width:"90%"}} id="outlined-basic" 
                            // aria-invalid={!isDirty ? undefined : errors.usedMethod ? "true" : "false"}
                            {...register("usedMethod", {
                                // required : t('message.common.error.text.used.equipment.input')
                            })} 
                            defaultValue={''}
                            sx={{ minWidth: '90%' }} />
                          {/* {errors.usedMethod && <small role="alert"><br></br>{errors.usedMethod.message}</small>} */}
                        </TableCell>
                      </TableRow>
          
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.worker')} *</TableCell>
                        <TableCell className="view_td">
                          <TextField style={{width:"90%"}} id="outlined-basic" 
                            aria-invalid={!isDirty ? undefined : errors.worker ? "true" : "false"}
                            {...register("worker", {
                                required : t('message.common.error.text.worker.input')
                            })} 
                            defaultValue={name || ''}
                            sx={{ minWidth: '90%' }} />
                            {errors.worker && <small role="alert"><br></br>{errors.worker.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.work.status')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            aria-invalid={!isDirty ? undefined : errors.status ? "true" : "false"}
                            control={control}
                            name="status"
                            render={({ field: {name} }) => (
                            <CustomFormEnumSelect
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.work.status')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.alert.work.status.select')}
                                defaultValue={''}
                                list={mtStatuss}
                            />
                            )}
                          />
                          {errors.status && <small role="alert"><br></br>{errors.status.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.actionType')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            aria-invalid={!isDirty ? undefined : errors.type ? "true" : "false"}
                            control={control}
                            name="type"
                            render={({ field: {name} }) => (
                            <CustomFormEnumSelect
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.actionType')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.actionType.select')}
                                defaultValue={''}
                                list={getEnumValueByEnumName("MaintenanceType")}
                            />
                            )}
                          />
                          {errors.type && <small role="alert"><br></br>{errors.type.message}</small>}
                        </TableCell>
                      </TableRow>
          
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.work.detail')} *</TableCell>
                        <TableCell colSpan="5">
                          <TextField style={{width:"98%"}} id="outlined-basic" 
                              aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                              {...register("remark", {
                                  required : t('message.common.error.text.work.detail.input')
                              })} 
                              multiline
                              rows={4}
                              sx={{ minWidth: '90%' }} />
                          {errors.remark && <small role="alert"><br></br>{errors.remark.message}</small>}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.equipment.component')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            aria-invalid={!isDirty ? undefined : errors.componentId ? "true" : "false"}
                            control={control}
                            name="componentId"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                style={{ minWidth: '90%', maxWidth: '110px' }}
                                label={t('message.common.subtitle.equipment.component')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.equipment.component.select')}
                                defaultValue={''}
                                onChange={(e)=>{
                                    setEquipmentCategoryComponentId(e.target.value);
                                }}
                                list={equipmentCategoryComponents}
                            />
                            )}
                          />
                          {errors.componentId && <small role="alert"><br></br>{errors.componentId.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.component.location')} *</TableCell>
                        <TableCell className="view_td">
                          <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            aria-invalid={!isDirty ? undefined : errors.position ? "true" : "false"}
                            control={control}
                            name="position"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.component.location')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.component.location.select')}
                                defaultValue={''}
                                list={equipmentCategoryPositions}
                            />
                            )}
                          />
                          {errors.position && <small role="alert"><br></br>{errors.position.message}</small>}
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.expense')}</TableCell>
                        <TableCell className="view_td">
                          <TextField style={{width:"90px"}} id="outlined-basic" 
                            {...register("cost", {
                            })} 
                            defaultValue={''}
                            sx={{ minWidth: '90%' }} />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell className="th">
                          {t('message.common.subtitle.input.material')}
                          <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addParts}>+</AddCircleOutlineIcon>
                        </TableCell>
                        <TableCell colSpan={4}>
                          {inputParts && inputParts.map(function(item, index) {
                            return (
                          <div className="plus" key={index}>
                            <Controller
                              sx={{ m: 1, minWidth: 150 }}
                              control={control}
                              name="equipmentPartsId"
                              render={({ field: {name} }) => (
                              <CustomFormSelect
                                  key={"equipmentPartsId_"+item.id}
                                  style={{ minWidth: 150, marginLeft: '8px' }}
                                  label={t('message.common.subtitle.input.material')}
                                  register={register}
                                  name={name}
                                  defaultValue={item.part.partId || ''}
                                  onChange={(e)=>{
                                    handleInputPartChange(e, index);
                                  }}
                                  list={(item.part && item.part.partId && item.part.id !== 0) ? masterEquipmentParts && masterEquipmentParts.filter(partItem => partItem.id===item.part.partId) : masterEquipmentParts}
                              />
                              )}
                            />
                            <div style={{marginLeft:"10px"}}>{t('message.common.subtitle.quantity')}</div>
                            <TextField 
                              key={"equipmentPartsCount_"+item.id}
                              id="outlined-basic" sx={{ m: 1, width: 50 }}
                              defaultValue={item.part.count || null}
                              onChange={(e)=>{handleInputPartCountChange(e, index)}} 
                            />
                            { inputParts[index] ? (
                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputPart(item.id)}>-</RemoveCircleOutlineIcon>
                            ) : (
                            ''
                            )}
                          </div>
                            )
                          })}
                        </TableCell>
                        <TableCell>
                          <EquipmentPartListLayer equipmentCtgrId={equipmentAlert.equipment.equipmentCtgr.id} />
                        </TableCell>
                      </TableRow>
          
                      <TableRow>
                        <TableCell className="th">{t('message.common.subtitle.status.report.date')}</TableCell>
                        <TableCell>
                          <div className="piker">
                            <Controller
                              control={control}
                              name="reportYmd"
                              render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                <CustomDatePicker
                                  field={field} ref={ref} name={name} value={value} register={register}
                                  fieldState={fieldState}
                                  hasAnyValue={hasAnyValue}
                                  validateMessage={t('message.common.alert.status.report.date.input')}
                                  />
                              )} />
                          </div>
                        </TableCell>
                        <TableCell className="th">{t('message.common.subtitle.status.reporter')}</TableCell>
                        <TableCell>
                          <TextField id="outlined-basic" 
                            {...register("reportUser", {
                              validate: (value) =>
                              !hasAnyValue || value ? true : t('message.common.alert.status.reporter.input'),
                            })} 
                            defaultValue={''}
                            sx={{ minWidth: '90%' }} />
                            {errors.reportUser && <small role="alert"><br></br>{errors.reportUser.message}</small>}
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="th">
                        {t('message.common.subtitle.status.report.file')}
                          <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addInputFile}>+</AddCircleOutlineIcon>
                        </TableCell>
                        <TableCell colSpan="5" className='view_td_left'>
                          {inputFiles && inputFiles.map(function(item, index) {
                            return (
                            <div key={index} style={{display:"flex"}}>
                                <input
                                    type="file"
                                    value={''}
                                    style={{width:"unset"}}
                                    onChange={e => {
                                      handleInputFileChange(e, index);
                                    }}
                                />
                                {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.id && <><FileDownloadIcon file={item.rFile} viewFileName={true} fontColor={"#000"}/></>)}
                                { inputFiles[index] ? (
                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputFile(item.id)}>-</RemoveCircleOutlineIcon>
                                ) : (
                                ''
                                )}
                            </div>
                            )
                            })}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </form>
              
              <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
                <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onMaintenanceTaskSubmit)}>{t('message.common.btn.maintenance.write')}</LoadingButton>
                <Button variant="contained" color="error" size="small" onClick={handleClose}>
                  {t('message.common.btn.cancel')}
                </Button>
              </Stack>
              </>
            }
            </CardContent>
            
            <Divider />

          </MainCard>
        </Modal>
        }
      </>
    )
}

export default ConstantInspectionFollowActionTypeRequestLayer;
